/**
 * Champs Puck partagés pour l'interaction média (cliquable + lien optionnel).
 * Utilisés par Media, TextImage, Heading/RichText (lien), Gallery/Carousel (cliquable multi).
 * `t` passé en argument — jamais d'appel `cmsNew` en portée module (re-évaluation
 * à chaque createPuckConfig / translationRevision).
 */

import { LinkTargetField } from "@/components/cms-puck/fields/LinkTargetField";
import { type ButtonLink } from "@/lib/cms-puck/blocks/button";
import { cmsNew } from "@/lib/cms/cms-new-i18n";
import { type CustomField } from "@measured/puck";

type CmsNewFn = typeof cmsNew;

/** Champ radio « Images cliquables » (Galerie & Carousel). */
export function galleryClickableField(t: CmsNewFn) {
  return {
    type: "radio" as const,
    label: t("cms.new.auto.label.images_cliquables", "Images cliquables"),
    options: [
      {
        label: t(
          "cms.new.auto.label.cliquable_plein_ecran",
          "Oui (plein écran)",
        ),
        value: true,
      },
      { label: t("cms.new.auto.label.non", "Non"), value: false },
    ],
  };
}

/** Champ radio « Image cliquable » (Media, TextImage — un seul média). */
export function imageClickableField(t: CmsNewFn) {
  return {
    type: "radio" as const,
    label: t("cms.new.auto.label.image_cliquable", "Image cliquable"),
    options: [
      {
        label: t(
          "cms.new.auto.label.cliquable_plein_ecran",
          "Oui (plein écran)",
        ),
        value: true,
      },
      { label: t("cms.new.auto.label.non", "Non"), value: false },
    ],
  };
}

/**
 * Champ custom « Lien (optionnel) » (titre, image Media/TextImage).
 * Réutilise `LinkTargetField` (Page / URL / page spéciale / découpage).
 */
export function optionalLinkField(t: CmsNewFn): CustomField<ButtonLink> {
  return {
    type: "custom",
    label: t("cms.new.auto.label.lien_optionnel", "Lien (optionnel)"),
    render: ({ value, onChange }) => (
      <LinkTargetField
        value={value as ButtonLink | undefined}
        onChange={onChange}
        allowNone
      />
    ),
  };
}
